import { useEffect, useRef } from 'react';
import framework from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import SignInEN from 'pages/Auth/locales/SignIn_en_US';
import SignInFR from 'pages/Auth/locales/SignIn_fr_CA';
import { colors } from 'style/config';
import useAuthFlow from 'pages/Auth/hooks/useAuthFlow';

const { wrapFunctionalComponent } = framework;
const getText = LanguageLocaleUtils.getLocalisedDataFromResource(SignInEN, SignInFR);

/**
 * Auth/SignIn page shell (SIM-1 / ACS-4125).
 *
 * Renders the page landmark, focused H1 heading, and a screen-slot placeholder
 * that reflects the current step from useAuthFlow. Downstream stories will
 * render actual sign-in screens into this slot; per ADR-TS-001 this shell must
 * NOT import the deprecated modal form.
 */
const SignIn = () => {
    const { currentScreen } = useAuthFlow();
    const headingRef = useRef(null);

    useEffect(() => {
        if (headingRef.current) {
            headingRef.current.focus();
        }
    }, []);

    return (
        <main aria-labelledby='signin-heading'>
            <h1
                id='signin-heading'
                ref={headingRef}
                tabIndex={-1}
                css={styles.heading}
            >
                {getText('pageTitle')}
            </h1>
            <div
                data-testid='signin-screen-slot'
                data-current-screen={currentScreen}
            />
        </main>
    );
};

// AC-023 / SI-3: Emotion class-scoped color rule on the heading so the
// deterministic stylesheet scan finds a WCAG-AA-safe token color.
const styles = {
    heading: {
        color: colors.black
    }
};

export default wrapFunctionalComponent(SignIn, 'SignIn');
